// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-entity-types directly.

/**
 * docEntityTypeMap is a runtime object mapping each DocEntityType to itself.
 * This is useful for:
 * - Runtime iteration over all entity types
 * - Type narrowing and checking
 * - Ensuring exhaustive handling of entity types
 *
 * This object is auto-generated from the DocEntityHandle union type.
 */
export const docEntityTypeMap = {
  ANNOTATION: "ANNOTATION",
  ASSET: "ASSET",
  AUTO_DIMENSION: "AUTO_DIMENSION",
  BLOCK: "BLOCK",
  BUILDER_REF: "BUILDER_REF",
  CASEWORK: "CASEWORK",
  CATALOG_ITEM: "CATALOG_ITEM",
  CEILING: "CEILING",
  COLUMN: "COLUMN",
  COMPONENT: "COMPONENT",
  COMPONENT_INSTANCE: "COMPONENT_INSTANCE",
  COMPOSITE_LEVEL: "COMPOSITE_LEVEL",
  CONTENT_REPLICATOR: "CONTENT_REPLICATOR",
  CONTENT_TEMPLATE: "CONTENT_TEMPLATE",
  CONTENT_TEMPLATE_INSTANCE: "CONTENT_TEMPLATE_INSTANCE",
  DATA_SEQUENCE: "DATA_SEQUENCE",
  DATA_TABLE: "DATA_TABLE",
  DATUM: "DATUM",
  DOC_REF: "DOC_REF",
  DORMER: "DORMER",
  DRAWING_REF: "DRAWING_REF",
  EDGE: "EDGE",
  EDGE_BEHAVIOR: "EDGE_BEHAVIOR",
  EDGE_MODIFIER: "EDGE_MODIFIER",
  EDIT_MODE: "EDIT_MODE",
  EFFECT: "EFFECT",
  ELECTRICAL_DEVICE: "ELECTRICAL_DEVICE",
  ELECTRICAL_LAYOUT: "ELECTRICAL_LAYOUT",
  ELECTRICAL_RULE: "ELECTRICAL_RULE",
  ELEVATION: "ELEVATION",
  ELEVATION_VIEW: "ELEVATION_VIEW",
  ENTITY_SETTINGS: "ENTITY_SETTINGS",
  FACADE: "FACADE",
  FACADE_SPAN_STRATUM: "FACADE_SPAN_STRATUM",
  FACADE_SWEEP_STRATUM: "FACADE_SWEEP_STRATUM",
  FLOOR: "FLOOR",
  FLOOR_BAY: "FLOOR_BAY",
  FLOOR_FINISH: "FLOOR_FINISH",
  FLOOR_PERIMETER_OPENING: "FLOOR_PERIMETER_OPENING",
  FLOOR_SPLIT_LINE: "FLOOR_SPLIT_LINE",
  FLOOR_SYSTEM: "FLOOR_SYSTEM",
  FOUNDATION: "FOUNDATION",
  FOUNDATION_ASSEMBLY: "FOUNDATION_ASSEMBLY",
  FOUNDATION_COMPONENT: "FOUNDATION_COMPONENT",
  FOUNDATION_SYSTEM: "FOUNDATION_SYSTEM",
  FRAME_FLOOR_ASSEMBLY: "FRAME_FLOOR_ASSEMBLY",
  FRAMING_COMPONENT: "FRAMING_COMPONENT",
  GENERATED_ENTITY: "GENERATED_ENTITY",
  GLOBAL_PARAMETER: "GLOBAL_PARAMETER",
  GROUP: "GROUP",
  HEADER_ASSEMBLY: "HEADER_ASSEMBLY",
  INDETERMINATE_ENTITY_TYPE: "INDETERMINATE_ENTITY_TYPE",
  INSTANCE_OPTION_SET: "INSTANCE_OPTION_SET",
  LABEL: "LABEL",
  LEVEL: "LEVEL",
  LOCAL_PARAMETER: "LOCAL_PARAMETER",
  MASONRY_COMPONENT: "MASONRY_COMPONENT",
  MEASUREMENT: "MEASUREMENT",
  MODIFIER: "MODIFIER",
  OPENING: "OPENING",
  OPTION: "OPTION",
  OPTION_EFFECT: "OPTION_EFFECT",
  OPTION_LOCK: "OPTION_LOCK",
  OPTION_RULE: "OPTION_RULE",
  OPTION_SET: "OPTION_SET",
  OPTION_SET_OVERRIDES: "OPTION_SET_OVERRIDES",
  OPTION_SET_REF: "OPTION_SET_REF",
  OPTION_TEMPLATE: "OPTION_TEMPLATE",
  PALETTE: "PALETTE",
  PLAN_SET_TEMPLATE: "PLAN_SET_TEMPLATE",
  PLAN_SET_TEMPLATE_CONFIG: "PLAN_SET_TEMPLATE_CONFIG",
  PLAN_VIEW: "PLAN_VIEW",
  PRESET: "PRESET",
  PROFILE: "PROFILE",
  PROP: "PROP",
  PROP_INSTANCE: "PROP_INSTANCE",
  RAILING: "RAILING",
  RAILING_POST: "RAILING_POST",
  REFERENCE_GEOM: "REFERENCE_GEOM",
  REPORTABLE_UNIT_DESIGNATION: "REPORTABLE_UNIT_DESIGNATION",
  ROOF: "ROOF",
  ROOF_OPENING: "ROOF_OPENING",
  ROOF_SIDE: "ROOF_SIDE",
  ROOF_SYSTEM: "ROOF_SYSTEM",
  ROOF_VOLUME: "ROOF_VOLUME",
  ROOM: "ROOM",
  ROOM_LAYOUT: "ROOM_LAYOUT",
  ROOM_LAYOUT_INSTANCE: "ROOM_LAYOUT_INSTANCE",
  RULE_BASED_SELECTOR: "RULE_BASED_SELECTOR",
  RULE_BASED_SELECTOR_INSTANCE: "RULE_BASED_SELECTOR_INSTANCE",
  SECTION_VIEW: "SECTION_VIEW",
  SELECTOR: "SELECTOR",
  SETTINGS: "SETTINGS",
  SETTINGS_SET: "SETTINGS_SET",
  SHAPE: "SHAPE",
  SHEATHING_COMPONENT: "SHEATHING_COMPONENT",
  SHEET: "SHEET",
  SITE: "SITE",
  SITE_SHAPE: "SITE_SHAPE",
  SKYLIGHT: "SKYLIGHT",
  SLAB_COMPONENT: "SLAB_COMPONENT",
  SLAB_FLOOR_ASSEMBLY: "SLAB_FLOOR_ASSEMBLY",
  STAIR_BLOCK: "STAIR_BLOCK",
  STAIR_SYSTEM: "STAIR_SYSTEM",
  SYSTEM_PARAMETER: "SYSTEM_PARAMETER",
  UNDERLAY: "UNDERLAY",
  VERTEX: "VERTEX",
  VIEW_3D: "VIEW_3D",
  VIEW_OVERRIDE: "VIEW_OVERRIDE",
  VIEW_SELECTOR: "VIEW_SELECTOR",
  VIEW_TEMPLATE: "VIEW_TEMPLATE",
  VIEW_TEMPLATE_OVERRIDE: "VIEW_TEMPLATE_OVERRIDE",
  VIEWPORT: "VIEWPORT",
  WALL_PLANE_ASSEMBLY: "WALL_PLANE_ASSEMBLY",
  WALL_PLANE_FILTER: "WALL_PLANE_FILTER",
  WALL_PLANE_RULE: "WALL_PLANE_RULE",
  WALL_PLANE_TRIM: "WALL_PLANE_TRIM",
} as const;

export type DocEntityType = keyof typeof docEntityTypeMap;

export const docEntityTypes = Object.keys(docEntityTypeMap) as DocEntityType[];

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-entity-types directly.
